import template from './mx-shell-error-message.html';
import './mx-shell-error-message.scss';
import type { I18n } from '../../i18n/mx-internationalization';

/**
 * @ngdoc component
 * @name mx.shell:mxShellErrorMessage
 * @module mx.shell
 * @description Error component that opens in the center of an area where error occurs. Has image, error titel and error description
 * @param {string} errorTitle<? error title
 * @param {string} error< error body
 * @usage <mx-shell-error-message error="vm.error"></mx-shell-error-message>
 */
class MxShellErrorMessageCtrl {
	static readonly $inject = ['mx.internationalization'];
	error?: string;
	errorTitle?: string;

	constructor(private readonly i18n: I18n) {}

	$onInit() {
		this.errorTitle = this.errorTitle || this.i18n.get('shell.mx-shell-error-message.error-label');
		this.error = this.error || this.i18n.get('shell.mx-shell-error-message.default-description');
	}
}

export const mxShellErrorMessageComponent = {
	bindings: {
		errorTitle: '<?',
		error: '<',
	},
	controller: MxShellErrorMessageCtrl,
	controllerAs: 'vm',
	template: template,
};
